<div class="container">
  <h1 class="title">{{'locker.company.title'|traduccion}}</h1>

  <button mat-raised-button color="primary" (click)="openNew()"><mat-icon>add</mat-icon></button>

  <div class="table-container">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay empresas disponibles.'"
      [rowClickable]="true"
      (rowClick)="openDetails($event.row)">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{'locker.company.table.header.id'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{'locker.company.table.header.name'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="domain">
        <th mat-header-cell *matHeaderCellDef>{{'locker.company.table.header.domain'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.domain }}</td>
      </ng-container>
    </app-data-table>
  </div>
</div>
